import { Badge } from "reactstrap";

const VerifiedBadge = ({ isVerified }) => {
  return (
    <Badge color={isVerified ? "success" : "danger"} className="badge-dim">
      {isVerified ? "تایید شده" : "تایید نشده"}
    </Badge>
  );
};

export default VerifiedBadge;
